<template>
  <main class="main profile-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">My Profile</div>
          <div class="profile-form">
            <div class="profile-form-wrapper">
              <div class="wrapper">
                <div class="title">Personal Information</div>
                <div>
                  <div class="input-container">
                    <div class="desc">*First name:</div>
                    <input
                      type="text"
                      placeholder="First name"
                      v-model="name"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc">*E-mail:</div>
                    <input type="email" placeholder="E-mail" v-model="email" />
                  </div>
                  <div class="input-container">
                    <div class="desc">*Last name:</div>
                    <input
                      type="text"
                      placeholder="Last name"
                      v-model="surname"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc">*Phone:</div>
                    <input type="tel" placeholder="Phone" v-model="phone" />
                  </div>
                </div>
                <button class="button long" @click="updateProfileData">
                  <span>Save Changes</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="profileUpdateErrorMessaage">
                    {{ profileUpdateErrorMessaage }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="profileUpdateSuccessMessaage">
                    {{ profileUpdateSuccessMessaage }}
                  </div>
                </transition>
              </div>
              <div class="wrapper">
                <div class="title">Change Password</div>
                <div class="input-container long">
                  <div class="desc">*Current password:</div>
                  <input
                    type="password"
                    placeholder="Current password"
                    v-model="curPass"
                  />
                </div>
                <div class="input-container long">
                  <div class="desc">*New password:</div>
                  <input
                    type="password"
                    placeholder="New password"
                    v-model="newPass"
                  />
                </div>
                <div class="input-container long">
                  <div class="desc">*Confirm password:</div>
                  <input
                    type="password"
                    placeholder="Confirm password"
                    v-model="repeatPass"
                  />
                </div>
                <button class="button long" @click="updatePassword">
                  <span>Save Changes</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="passUpdateErrorMessaage">
                    {{ passUpdateErrorMessaage }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="passUpdateSuccessMessaage">
                    {{ passUpdateSuccessMessaage }}
                  </div>
                </transition>
              </div>
            </div>
          </div>

          <!-- Orders Section -->
          <div
            class="profile-table"
            v-if="$parent.orderHistory && $parent.orderHistory.length"
          >
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="title">Your Orders</div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Date/time</td>
                      <td>Skin name</td>
                      <td>Total</td>
                      <td>Status</td>
                      <td>Details</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ $parent.formatDate(item.created_at) }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.sum }} {{ item.currency }}</td>
                      <td>{{ item.status }}</td>
                      <td>
                        <a
                          class="offer-modal-open"
                          @click="openOrderDetails(item)"
                          >View</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>

          <!-- Offers Section (conditional) -->
          <div class="profile-table" v-if="$parent.offerEnabled">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="title">Your Offers</div>
              <div class="sell-offers-button" style="margin-bottom: 20px">
                <button class="button" @click="$parent.openSaleSkinModal">
                  <span>Sell skins</span>
                </button>
              </div>
              <div
                class="table-container"
                v-if="$parent.offerHistory && $parent.offerHistory.length"
              >
                <table>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Date/time</td>
                      <td>Skin name</td>
                      <td>Total</td>
                      <td>Status</td>
                      <td>Details</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.offerHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ $parent.formatDate(item.date_time) }}</td>
                      <td>{{ item.title }}</td>
                      <td>
                        {{ item.service_price || item.user_price }}
                        {{ item.currency }}
                      </td>
                      <td :class="statusClass(item.status)">
                        <span class="status">{{
                          formatStatus(item.status)
                        }}</span>
                      </td>
                      <td>
                        <a
                          class="offer-modal-open"
                          v-if="item.status == 'ready_for_payout'"
                          @click="openAcceptOffer(item)"
                        >
                          View
                        </a>
                        <a
                          class="offer-modal-open"
                          v-else
                          @click="openOfferDetails(item)"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                v-else
                class="no-offers-message"
                style="
                  margin-left: 30px;
                  color: #8d8e92;
                  font-size: 16px;
                  margin-top: 20px;
                "
              >
                No offers yet. Click "Sell skins" to create your first offer.
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "Profile",
  props: [],
  components: {},
  data: function () {
    return {
      email: "",
      name: "",
      surname: "",
      phone: "",
      profileUpdateSuccessMessaage: "",
      profileUpdateErrorMessaage: "",
      curPass: "",
      newPass: "",
      repeatPass: "",
      passUpdateSuccessMessaage: "",
      passUpdateErrorMessaage: "",
    };
  },
  mounted() {
    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      });
  },
  methods: {
    openOfferDetailsModal() {
      this.$emit("openOfferDetailsModal");
    },
    formatStatus(status) {
      if (!status) return "";
      return status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
    statusClass(status) {
      switch (status) {
        case "completed":
        case "delivered":
        case "approved":
        case "ready_for_payout":
          return "green";
        case "cancelled":
        case "failed":
        case "declined_by_user":
        case "declined_by_service":
          return "red";
        case "processing":
        case "pending":
          return "orange";
        default:
          return "";
      }
    },
    getOrderItemNames(order) {
      if (order.items && order.items.length > 0) {
        return order.items.map((item) => item.name || item.title).join(", ");
      }
      return order.item_name || order.title || "N/A";
    },
    openOrderDetails(item) {
      this.$parent.openOrderDetailsModal(item);
    },
    openOfferDetails(item) {
      this.$parent.openOfferDetailsModal(item);
    },
    openAcceptOffer(item) {
      this.$parent.openAcceptOfferModal(item);
    },
    updateProfileData() {
      let profileData = {
        email: this.email,
        name: this.name,
        phone: this.phone,
        surname: this.surname,
      };
      this.$http
        .put(process.env.VUE_APP_API + "user/profile", profileData)
        .then((res) => {
          if (res.data.status == "OK") {
            this.profileUpdateSuccessMessaage = "Success";
            setTimeout(() => {
              this.profileUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
          this.profileUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.profileUpdateErrorMessaage = "";
          }, 3000);
        });
    },
    updatePassword() {
      let passwordList = {
        cur_password: this.curPass,
        new_password: this.newPass,
        repeat_password: this.repeatPass,
      };
      this.$http
        .post(process.env.VUE_APP_API + "user/change-password", passwordList)
        .then((res) => {
          if (res.data.status == "OK") {
            this.passUpdateSuccessMessaage = "Success";
            (this.curPass = ""), (this.newPass = ""), (this.repeatPass = "");
            setTimeout(() => {
              this.passUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
          this.passUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.passUpdateErrorMessaage = "";
          }, 3000);
        });
    },
  },
};
</script>

<style scoped>
.profile-table {
  margin-top: 29px;
}

.profile-form-wrapper {
  background: #22202f;
  border-radius: 16px;
  padding: 42px;
  margin-top: 42px;
  text-align: left;
}

.profile-table .profile-form-wrapper {
  margin-top: 29px;
  padding: 42px 12px;
}

.profile-table .profile-form-wrapper .title {
  margin-left: 30px;
  font-family: Poppins, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 35px;
  color: #fff;
}

.profile-table .profile-form-wrapper table {
  margin-top: 33px;
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  border-spacing: 0;
}

.profile-table .profile-form-wrapper td:first-child {
  padding-left: 30px;
}

.profile-table .profile-form-wrapper thead td {
  color: #8d8e92;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  font-family: Poppins, sans-serif;
  padding-bottom: 11px;
}

.profile-table .profile-form-wrapper tbody tr:nth-child(odd) td {
  background: hsla(0, 0%, 100%, 0.07);
}

.profile-table .profile-form-wrapper tbody td {
  padding: 12px 0;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #fff;
}

.profile-table td a {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #1dc0fc;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
}

.profile-table td a:hover {
  opacity: 0.5;
}

.table-container {
  overflow: auto;
}

.pagination {
  margin-top: 30px;
  width: 100%;
  padding-right: 30px;
}

.status.green {
  color: #4caf50;
}

.status.red {
  color: #f44336;
}

.status.orange {
  color: #ff9800;
}

.sell-offers-button {
  margin-left: 30px;
}

@media screen and (max-width: 768px) {
  .profile-form-wrapper {
    padding: 16px;
  }

  .profile-table .pagination {
    padding-right: 0;
  }
}
</style>
